export class EventCategory {
  id = 0
  name = ""
  slug = ""
  description = ""
  color = "#38bdf8"
  sortOrder = 0
  active = true

  parseJson(ret: { id: number; attributes: { [key: string]: any } } | null | undefined) {
    if (!ret?.attributes) return

    this.id = ret.id
    this.name = String(ret.attributes.Name ?? "")
    this.slug = String(ret.attributes.slug ?? "")
    this.description = String(ret.attributes.Description ?? "")
    this.color = String(ret.attributes.color ?? "#38bdf8")
    this.sortOrder = Number(ret.attributes.sortOrder ?? 0)
    this.active = ret.attributes.active ?? true
  }

  toApiJSON() {
    return {
      Name: this.name,
      Description: this.description,
      color: this.color,
      sortOrder: this.sortOrder,
      active: this.active,
    }
  }
}
